import React, { useState } from "react";
import classNames from "classnames";

import Icon, { IconType } from "../Icon/Icon";
import styles from "./Tooltip.module.scss";

interface Props {
  dataQA: string;
  icon?: {
    type: IconType;
    width?: number;
    height?: number;
    className?: string;
  };
  triggerComponent?: React.ReactNode;
  className?: string;
  children?: React.ReactNode;
}

const Tooltip: React.FC<Props> = ({
  icon = {
    type: "AddCircleOutlineIcon",
    width: 20,
    height: 20,
    className: styles.infoIcon,
  },
  triggerComponent,
  className,
  children,
  dataQA,
}) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div data-qa={dataQA} className={classNames(styles.container, className)}>
      <div
        data-qa="tooltip-trigger"
        className={styles.triggerWrapper}
        onMouseOver={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
      >
        {triggerComponent ? triggerComponent : <Icon {...icon} dataQA="icon" />}
        {isVisible && (
          <div data-qa="tooltip-description" className={styles.tooltip}>
            {children}
          </div>
        )}
      </div>
    </div>
  );
};

export default Tooltip;
